import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function useMobileLayout() {
  const theme = useTheme();
  // DO NOT ADJUST without first checking all other theme.breakpoints usages!
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return isMobile;
}
